import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-image-view-dialog',
  // templateUrl: './image-view-dialog.component.html',
   template: `<img [src]="data.url" style="max-width:100%; height:auto;" />`,
  styleUrl: './image-view-dialog.component.css'
})
export class ImageViewDialogComponent {
 constructor(@Inject(MAT_DIALOG_DATA) public data: { url: string }) {}
}
